// material-ui
import { AlertProps } from '@mui/material/Alert';
import { ButtonProps } from '@mui/material/Button';

export interface Notification {
  id: string;
  notificationId?: string;
  type: string;
  category?: string;
  requestLink?: string;
  user: {
    name: string;
    avatar: string;
  } | null;
  title?: string;
  message: string;
  time: string;
  read: boolean;
  createdAt?: string;
  context?: string;
  file?: {
    name: string;
    size: string;
    icon: string;
  };
  reply_content?: string;
  actions?: (
    | string
    | {
        type: 'button';
        buttonProps: ButtonProps;
        action_id: string;
      }
    | {
        type: 'alert';
        alertProps: AlertProps;
        action_id: string;
      }
  )[];
}

export const notificationFilterOptions = [
  { key: 'all', label: 'All' },
  { key: 'unread', label: 'Unread' },
  { key: 'mentions', label: 'Mentions' }
] as Array<{ key: 'all' | 'unread' | 'mentions'; label: string }>;
